// extracted by mini-css-extract-plugin
export var conversationListItem = "_xh-2";
export var fullBleedList = "_xh-3";
export var messageText = "_xh-1";
export var previewText = "_xh-0";